import { Backdrop, Button, LogoLoader, TableAdv } from "../../../components";
import { usePagination } from "../../../hooks";
import EmailReports from "./AtsTabs/EmailReport";
import RaReports from "./AtsTabs/RaReports";
import { mapTableRows } from "../../../utils";
import BdmReports from "./AtsTabs/BdmReports";
import RecruiterReports from "./AtsTabs/RecruiterReports";
import { use, useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  bdmReportsListStart,
  raReportsListStart,
  recruiterEmailDelivaryReportsListStart,
  recruiterReportsListStart,
} from "../../../redux/slices/reports/reportListSlice";
import {
  addBdmFavouriteReportStart,
  addRaFavouriteReportStart,
  addRecruiterEmailDelivaryFavouriteReportStart,
  addRecruiterFavouriteReportStart,
  bdmFavouriteReportsStart,
  deleteBdmFavouriteReportStart,
  deleteRaFavouriteReportStart,
  deleteRecruiterEmailDelivaryFavouriteReportStart,
  deleteRecruiterFavouriteReportStart,
  raFavouriteReportsStart,
  recruiterEmailDelivaryFavouriteReportsStart,
} from "../../../redux/slices/reports/favouriteReportsSlice";
import { debounce } from "lodash";

const ReportsTable = ({
  selectedReport,
  setSelectedReport,
  type,
  isFavourite,
}) => {
  const reportsList = useSelector((state) => state.reportsList);
  const favouriteReports = useSelector((state) => state.favouriteReports);
  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  // const [favourites, setFavourites] = useState({
  //     RA: [],
  //     BDM: [],
  //     RECRUITER: [],
  //     EMAIL: []
  // });
  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {},
  );

  const startActionMap = {
    RA: {
      action: raReportsListStart,
      category: "RA",
      typeNumber: 1,
      reportOptions: reportsList?.raReportsList?.data,
      favReportsAction: raFavouriteReportsStart,
      favouriteReportsSlice: favouriteReports?.raFavouriteReports?.data,
      favouriteReports: reportsList?.raReportsList?.data.filter((report) =>
        favouriteReports?.raFavouriteReports?.data?.some(
          (fav) => fav.reportId === report.uiid,
        ),
      ),
      addFavAction: addRaFavouriteReportStart,
      deleteFavAction: deleteRaFavouriteReportStart,
    },
    BDM: {
      action: bdmReportsListStart,
      category: "BDM",
      typeNumber: 2,
      reportOptions: reportsList?.bdmReportsList?.data,
      favReportsAction: bdmFavouriteReportsStart,
      favouriteReportsSlice: favouriteReports?.bdmFavouriteReports?.data,
      favouriteReports: reportsList?.bdmReportsList?.data.filter((report) =>
        favouriteReports?.bdmFavouriteReports?.data?.some(
          (fav) => fav.reportId === report.uiid,
        ),
      ),
      addFavAction: addBdmFavouriteReportStart,
      deleteFavAction: deleteBdmFavouriteReportStart,
    },
    RECRUITER: {
      action: recruiterReportsListStart,
      category: "Recruitment",
      typeNumber: 3,
      reportOptions: reportsList?.recruiterReportsList?.data,
      favReportsAction: recruiterEmailDelivaryFavouriteReportsStart,
      favouriteReportsSlice: favouriteReports?.recruiterFavouriteReports?.data,
      favouriteReports: reportsList?.recruiterReportsList?.data.filter(
        (report) =>
          favouriteReports?.recruiterFavouriteReports?.data?.some(
            (fav) => fav.reportId === report.uiid,
          ),
      ),
      addFavAction: addRecruiterFavouriteReportStart,
      deleteFavAction: deleteRecruiterFavouriteReportStart,
    },
    EMAIL: {
      action: recruiterEmailDelivaryReportsListStart,
      category: "Email Report",
      typeNumber: 4,
      reportOptions: reportsList?.recruiterEmailDelivaryReportsList?.data,
      favReportsAction: recruiterEmailDelivaryFavouriteReportsStart,
      favouriteReportsSlice:
        favouriteReports?.recruiterEmailDelivaryFavouriteReports?.data,
      favouriteReports:
        reportsList?.recruiterEmailDelivaryReportsList?.data.filter((report) =>
          favouriteReports?.recruiterEmailDelivaryFavouriteReports?.data?.some(
            (fav) => fav.reportId === report.uiid,
          ),
        ),
      addFavAction: addRecruiterEmailDelivaryFavouriteReportStart,
      deleteFavAction: deleteRecruiterEmailDelivaryFavouriteReportStart,
    },
  };

  // const reportMap = {
  //     RA: [
  //         { id: "reports_ats_rareport_radownloadsheet", name: "RA Download Sheet" },
  //     ],
  //     BDM: [
  //         { id: "reports_ats_bdmreport_bdmsummaryreport", name: "BDM Summary Report" },
  //         { id: "reports_ats_bdmreport_clientengagementreport", name: "BDM Download Sheets" },
  //     ],
  //     RECRUITER: [
  //         { id: "reports_ats_recruiterreport_recruiterdownloadsheet", name: "Recruiter Summary Sheet" },
  //     ],
  //     EMAIL: [
  //         { id: "reports_ats_emailreport_recruiteremaildelivaryreport", name: "Recruiter Email Delivary Report" },
  //     ],
  // };

  // const reportOptions = reportMap[type] || [];

  const rows = startActionMap[type]?.reportOptions?.map((report, i) => {
    return {
      id: i + 100,
      reportName: report?.reportName,
      category: startActionMap[type]?.category,
      type: "Standard Reports",
      reportId: report?.uiid,
      tempRepId: report?.reportId,
      // Favourite: "iii",
    };
  });

  const columns = [
    {
      key: "reportName",
      label: "Report Name",
      render: (row) => {
        return (
          <div
            className="text-blue-600 cursor-pointer"
            onClick={() => setSelectedReport(row)}
          >
            {row?.reportName}
          </div>
        );
      },
    },
    {
      key: "category",
      label: "Category",
    },
    {
      key: "type",
      label: "Type",
    },
    {
      key: "Favourite",
      label: "Favourite",
      render: (row) => (
        <Button
          type="icon"
          icon={"star"}
          variant="text"
          size="md-lg"
          color={
            startActionMap[type].favouriteReports.some(
              (report) => report.uiid === row.reportId,
            )
              ? "warning"
              : "black"
          }
          className="text-gray-400"
          onClick={() => setFavouritesReports(row, type)}
        />
      ),
    },
  ];

  const mappedRows = mapTableRows(rows, columns);

  const setFavouritesReports = useCallback(
    debounce((row, reportType) => {
      try {
        if (
          startActionMap[type].favouriteReports.some(
            (report) => report.uiid === row.reportId,
          )
        ) {
          const currentFavReport = startActionMap[
            type
          ].favouriteReportsSlice.find(
            (report) => report.reportId === row.reportId,
          );
          const payload = {
            actualPayload: {
              uiid: currentFavReport?.uiid,
              reportCategory: startActionMap[reportType]?.typeNumber,
            },
            fetchPayload: {
              coll: "FavouriteReport",
              pg: page,
              lim: limit,
              fil: {
                reportCategory: {
                  type: "NONE",
                  value: startActionMap[type]?.typeNumber,
                },
              },
              reportType: type,
            },
          };
          dispatch(startActionMap[type].deleteFavAction(payload));
        } else {
          const payload = {
            actualPayload: {
              reportId: row?.reportId,
              reportCategory: startActionMap[reportType]?.typeNumber,
              userId: user?.data?.uiid,
            },
            fetchPayload: {
              coll: "FavouriteReport",
              pg: page,
              lim: limit,
              fil: {
                reportCategory: {
                  type: "NONE",
                  value: startActionMap[type]?.typeNumber,
                },
              },
              reportType: type,
            },
          };
          dispatch(startActionMap[type].addFavAction(payload));
        }
      } catch (err) {
        console.error("Error setting favourite report:", err);
      }
    }, 300),
    [dispatch, page, limit, type, startActionMap, user],
  );

  const fetchReportsList = async () => {
    try {
      const payload = {
        coll: "Report",
        pg: page,
        lim: limit,
        fil: {
          category: { type: "NONE", value: startActionMap[type]?.typeNumber },
        },
        reportType: type,
      };
      dispatch(startActionMap[type]?.action(payload));
    } catch (err) {
      console.error("Error fetching reports list:", err);
    }
  };

  const fetchFavReports = async () => {
    try {
      const payload = {
        coll: "FavouriteReport",
        pg: page,
        lim: limit,
        fil: {
          reportCategory: {
            type: "NONE",
            value: startActionMap[type]?.typeNumber,
          },
        },
        reportType: type,
      };
      dispatch(startActionMap[type]?.favReportsAction(payload));
    } catch (err) {
      console.error("Error fetching favourite reports list:", err);
    }
  };

  useEffect(() => {
    if (startActionMap[type].reportOptions.length === 0) {
      fetchReportsList();
      fetchFavReports();
    }
  }, [type, page, limit]);

  useEffect(() => {
    return () => {
      setFavouritesReports.cancel();
    };
  }, [setFavouritesReports]);

  if (selectedReport) {
    let SpecifiedReport;
    switch (type) {
      case "RA":
        SpecifiedReport = RaReports;
      case "BDM":
        SpecifiedReport = BdmReports;
      case "EMAIL":
        SpecifiedReport = EmailReports;
      case "RECRUITER":
        SpecifiedReport = RecruiterReports;
      default:
        SpecifiedReport = RaReports;
    }
    return (
      <div className="flex-1 p-2 flex flex-col">
        <SpecifiedReport
          selectedReport={selectedReport}
          setSelectedReport={setSelectedReport}
        />
      </div>
    );
  }

  if (isFavourite) {
    return (
      <div className="flex-1 flex flex-col overflow-hidden">
        <div className="font-semibold mt-2 mx-2">{`Favourite ${type} Reports`}</div>
        <TableAdv
          disableSelection={true}
          columns={columns}
          rows={mappedRows.filter((row) =>
            startActionMap[type].favouriteReports.some(
              (report) => report.uiid === row.reportId,
            ),
          )}
          page={1}
          limit={startActionMap[type].favouriteReports.length || 25}
          showCheckbox={false}
          showSlNo
          toolbarRight={{ search: true }}
          tableId={`${type.toLowerCase()}ReportsFavouritesTable`}
        />
      </div>
    );
  }

  return (
    <div className="flex-1 flex flex-col overflow-hidden">
      <div className="font-semibold mt-2 mx-2">All Reports</div>
      <TableAdv
      key={page}
        disableSelection={true}
        columns={columns}
        rows={mappedRows}
        page={page}
        limit={limit}
        showCheckbox={false}
        showSlNo
        toolbarRight={{ search: true }}
        tableId={`${type.toLowerCase()}ReportsTable`}
      />
      <Backdrop isOpen={reportsList?.loading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default ReportsTable;
